import TabOptions from '../options';
import SwAlert from '@/mixins/alert.mixin';

export class Model {}
export class Tab {
  id = 'Six';
  title = 'VI';
  model = new Model();
  valid = true;
  options = new TabOptions(new Model());
  build = (model) => {
    return {
      tab: this.id,
      ...model,
    };
  };
  confirm = async ({ hasOccupationalPairing }, { touchedTabs }) => {
    const tabs = ['Six', 'Seven', 'Eight'];

    const hasTouches = touchedTabs
      .filter((x) => x.touched)
      .map((x) => x.tab)
      .some((x) => tabs.includes(x));

    if (hasOccupationalPairing === false && hasTouches) {
      const { value, dismiss } = await SwAlert.methods.ShowCancelModalClosable(
        'Confirmación',
        '<div>La información registrada en las pestañas <b>VI</b>, <b>VII</b> y <b>VIII</b> se eliminará de forma permanente.</div><div>¿Desea continuar?</div>',
        'Sí',
        'No',
        false,
        false
      );
      const cancelled = ['close', 'backdrop'].includes(dismiss);
      const confirmed = !cancelled && value;
      return confirmed;
    }
    return true;
  };
}
export default new Tab();
